/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React, { useEffect, useImperativeHandle, useRef, useState } from "react";

const image = React.forwardRef((props, ref) => {
  // 状態定義
  const [url, setUrl] = useState();
  const [isPortrait, setIsPortrait] = useState(false);

  // 要素参照定義
  const imageRef = useRef(null);
  const wrapperRef = useRef(null);

  // 親要素から呼び出す関数定義
  useImperativeHandle(ref, () => ({
    resize: () => {
      resize();
    },
  }));

  // ウインドウサイズ変更時に画像のサイズ調整を行う
  const resizeObserver = new ResizeObserver(() => {
    resize();
  });

  useEffect(() => {
    setUrl(props.src);
    // 画像登録時にリサイズ検知機能を有効化する
    if (props.src) {
      resizeObserver.observe(document.body);
    } else {
      resizeObserver.disconnect();
    }
  }, [props.src]);

  // 幅ベース、高さベースのどちらでサイズ指定を行うかを画像の縦横比により決定
  const resize = () => {
    if (imageRef.current) {
      const imageH = Number(imageRef.current.height);
      const imageW = Number(imageRef.current.width);
      const wrapperW = Number(wrapperRef.current.getBoundingClientRect().width);
      setIsPortrait((imageH / imageW) * wrapperW > 88);
    }
  };

  return url ? (
    <div ref={wrapperRef} css={mtgWrapper}>
      <div css={mtgImgWrapper}>
        <img
          onLoad={resize}
          ref={imageRef}
          css={[mtgImg, isPortrait ? mtgImgPortrait : mtgImgLandscape]}
          src={url}
          alt={url}
        />
      </div>
      <div css={mtgCancelIcon} onClick={props.onDelete}></div>
    </div>
  ) : null;
});

// cssの設定
const mtgWrapper = css`
  width: 100%;
  position: relative;
  text-align: center;
  margin: 20px 0 15px 0;
`;
const mtgImgWrapper = css`
  background-color: var(--mtg-white);
  filter: drop-shadow(0px 2px 5px rgba(24, 26, 36, 0.25));
  height: 88px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const mtgImg = css`
  vertical-align: bottom;
`;

const mtgImgPortrait = css`
  height: 88px;
`;

const mtgImgLandscape = css`
  width: 100%;
`;

const mtgCancelIcon = css`
  cursor: pointer;
  display: block;
  position: absolute;
  top: -11px;
  left: -11px;
  width: 22px;
  height: 22px;
  background: var(--mtg-urbanblue); /* ボタンの背景色 */
  border-radius: 50%;
  &:before,
  &:after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1px; /* 棒の幅（太さ） */
    height: 9px; /* 棒の高さ */
    background: var(--mtg-white);
  }
  &:before {
    transform: translate(-50%, -50%) rotate(45deg);
  }
  &:after {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
`;

export default image;
